module.exports = __webpack_public_path__ + "static/media/view-logo-profile.477e3a49.png";